import axios from "axios";
import { BASEURL } from "../Config";

export const LOGIN_USER = 'LOGIN_USER';
export const LOGGING_IN_USER = 'LOGGING_IN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const GET_BOOK_INFO = 'GET_BOOK_INFO';
export const GETTING_BOOK_INFO = 'GETTING_BOOK_INFO';
export const GET_CLASS_INFO = 'GET_CLASS_INFO';
export const GETTING_CLASS_INFO = 'GETTING_CLASS_INFO';
export const GET_CHAPTER_INFO = 'GET_CHAPTER_INFO';
export const GETTING_CHAPTER_INFO = 'GETTING_CHAPTER_INFO';
export const GET_ELP_CHAPTER_INFO = 'GET_ELP_CHAPTER_INFO';
export const GETTING_ELP_CHAPTER_INFO = 'GETTING_ELP_CHAPTER_INFO';
export const GET_TOPIC_INFO = 'GET_TOPIC_INFO';
export const GETTING_TOPIC_INFO = 'GETTING_TOPIC_INFO';

export const loginUser = (username, password) => dispatch => {
    dispatch({
        type: LOGGING_IN_USER,
        status: true
    })
    console.log(username, password);
    let data = { username: username, password: password };
    axios.post(`${BASEURL}/api/v1/admin/login`, data)
        .then(userData => {
            if (userData.status === 200) {
                dispatch({
                    type: LOGIN_USER,
                    userData: userData.data,
                    isAuthenticated: true
                })
                dispatch({
                    type: LOGGING_IN_USER,
                    status: false
                })
            }
            else {
                dispatch({
                    type: LOGGING_IN_USER,
                    status: false
                })
            }
        })
        .catch(err => {
            console.log(err.response.data);
            dispatch({
                type: SET_ERROR_MESSAGE,
                error: err.response.data
            })
            setTimeout(dispatch({
                type: SET_ERROR_MESSAGE,
                error: ""
            }), 5000);
            dispatch({
                type: LOGGING_IN_USER,
                status: false
            })
        })
}

export const logoutUser = () => dispatch => {
    dispatch({
        type: LOGOUT_USER
    })
}

export const getBookInfo = (bid) => dispatch => {
    dispatch({
        type: GETTING_BOOK_INFO,
        status: true,
    })
    // console.log('bid in action', bid)
    axios.get(`${BASEURL}/api/v1/books/fetch/${bid}`)
        .then(res => {
            if (res.status === 200) {
                // console.log('book response', res.data);
                dispatch({
                    type: GET_BOOK_INFO,
                    book: res.data
                })
                dispatch({
                    type: GETTING_BOOK_INFO,
                    status: false,
                })
            }
        })
        .catch((err) => {
            console.log('Fetch Book Error', err);
            dispatch({
                type: GETTING_BOOK_INFO,
                status: false,
            })
        })
}

export const getChapterInfo = (cid) => dispatch => {
    dispatch({
        type: GETTING_CHAPTER_INFO,
        status: true,
    })
    axios.get(`${BASEURL}/api/v1/chapters/fetch/${cid}`)
        .then(res => {
            if (res.status === 200) {
                // console.log('chapter response', res.data);
                dispatch({
                    type: GET_CHAPTER_INFO,
                    chapter: res.data
                })
                dispatch({
                    type: GETTING_CHAPTER_INFO,
                    status: false,
                })
            }
        })
        .catch((err) => {
            console.log('Fetch Chapter Error', err);
            dispatch({
                type: GETTING_CHAPTER_INFO,
                status: false,
            })
        })
}

export const getTopicInfo = (tid) => dispatch => {
    dispatch({
        type: GETTING_TOPIC_INFO,
        status: true,
    })
    axios.get(`${BASEURL}/api/v1/topics/fetch/${tid}`)
        .then(res => {
            if (res.status === 200) {
                dispatch({
                    type: GET_TOPIC_INFO,
                    topic: res.data
                })
                dispatch({
                    type: GETTING_TOPIC_INFO,
                    status: false,
                })
            }
        })
        .catch((err) => {
            console.log('Fetch Topic Error', err);
            dispatch({
                type: GETTING_TOPIC_INFO,
                status: false,
            })
        })
}

export const getClassInfo = (bid) => dispatch => {
    dispatch({
        type: GETTING_CLASS_INFO,
        status: true,
    })
    // console.log('bid in action', bid)
    axios.get(`${BASEURL}/api/v1/elp/classes/fetch/${bid}`)
        .then(res => {
            if (res.status === 200) {
                // console.log('book response', res.data);
                dispatch({
                    type: GET_CLASS_INFO,
                    class: res.data
                })
                dispatch({
                    type: GETTING_CLASS_INFO,
                    status: false,
                })
            }
        })
        .catch((err) => {
            console.log('Fetch Book Error', err);
            dispatch({
                type: GETTING_BOOK_INFO,
                status: false,
            })
        })
}


export const getElpChapterInfo = (cid) => dispatch => {
    dispatch({
        type: GETTING_ELP_CHAPTER_INFO,
        status: true,
    })
    axios.get(`${BASEURL}/api/v1/elp/chapters/fetch-by-uuid/${cid}`)
        .then(res => {
            if (res.status === 200) {
                // console.log('chapter response', res.data);
                dispatch({
                    type: GET_ELP_CHAPTER_INFO,
                    chapter: res.data
                })
                dispatch({
                    type: GETTING_ELP_CHAPTER_INFO,
                    status: false,
                })
            }
        })
        .catch((err) => {
            console.log('Fetch Chapter Error', err);
            dispatch({
                type: GETTING_CHAPTER_INFO,
                status: false,
            })
        })
}